
namespace SP {
    export interface PackageInfo {
        id: string;
        number: string;
        orderId: number;
        height: number;
        length: number;
        width: number;
        weight: number;
        state: PackageState;
        trackingNumber: string;
        deliveryMethodId: string;
        deliveryMethodName: string;
        droppointId: string;
        parcelType: string;
        packagingId: string;
        isReturn: boolean;
        deliveryInstructions: string;
        orderNo: string;
        referenceNo: string;
        isColli: boolean;
        parentPackageId: string;
        packageCollectionId: number;
        lines: PackageLine[];
    }

}
